class TipoTarefaSolMovIBPEnum {

    constructor(descricao, value) {
        this.descricao = descricao;
        this.value = value;
    }

    static fromValue(value) {
        return Object.values(TipoTarefaSolMovIBPEnum).find(status => status.value === value);
    }

    static fromDescricao(descricao) {
        return Object.values(TipoTarefaSolMovIBPEnum).find(status => status.descricao === descricao);
    }
}


TipoTarefaSolMovIBPEnum.APROVACAO_ORIGEM = new TipoTarefaSolMovIBPEnum("Aprovação Origem", 2);
TipoTarefaSolMovIBPEnum.APROVACAO_RESPONSAVEL = new TipoTarefaSolMovIBPEnum("Aprovação responsável", 3);
TipoTarefaSolMovIBPEnum.APROVACAO_DESTINO = new TipoTarefaSolMovIBPEnum("Aprovação destino", 4);
TipoTarefaSolMovIBPEnum.EXECUCAO_RETIRADA = new TipoTarefaSolMovIBPEnum("Execução retirada", 5);
TipoTarefaSolMovIBPEnum.EXECUCAO_ENTRADA = new TipoTarefaSolMovIBPEnum("Execução entrada", 6);


export default TipoTarefaSolMovIBPEnum;